const EMPTY_OBJECT: Readonly<Record<string, never>> = Object.freeze({});

export default EMPTY_OBJECT;
